export const AssetsRoute = {
  Assets: (): string => '/pools/user/assets',
  Uptime: (): string => '/pools/user/assets/uptime',
  UptimeToggle: (): string => '/pools/user/assets/uptime-toggle',
};
